import type { IconSvgObject } from './types';

const ArrowMoveRightDownIcon: IconSvgObject = [
  ["path", { d: "M21.0006 5.00013L8 5.00012C6.89543 5.00012 6 5.89555 6 7.00012V22.0001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 2L21 5.00012L18 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 19L6 21.9999L3 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowMoveRightDownIcon;
